import React, {useState, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {DataStep2} from './SettingsModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'
import dayjs from 'dayjs'

const profileDetailsSchema = Yup.object().shape({
  deal_id: Yup.string().required(''),
  display: Yup.string().required(''),
  quota_campaign: Yup.string().required(''),
  quota_member: Yup.string().required(''),
  redeem: Yup.string().required(''),
})

const Step2 = (props: any) => {
  const navigate = useNavigate()
  const API_URL = process.env.REACT_APP_API_URL
  const PVL_URL2 = process.env.REACT_APP_PVL_URLV2
  const dataLocal = localStorage.getItem('data2')
  const initialValues: DataStep2 = {
    deal_id: 0,
    display: {},
    quota_campaign: [],
    quota_member: [],
    redeem: [],
  }
  const [data, setData] = useState<DataStep2>(initialValues)
  const [startDateDisplay, setStartDateDisplay] = useState<any>('')
  const [endDateDisplay, setEndDateDisplay] = useState<any>('')
  const [startDateRedeem, setStartDateRedeem] = useState<any>('')
  const [endDateRedeem, setEndDateRedeem] = useState<any>('')
  const [redeemLimit, setRedeemLimit] = useState<any>(0)
  const [redeemQuota, setRedeemQuota] = useState<any>(0)
  const [change, setChange] = useState(false)

  const updateData = (fieldsToUpdate: Partial<DataStep2>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }

  const AlertError = (message: string) => {
    Swal.fire('', message, 'error')
  }

  const getStep2Data = async () => {
    if (dataLocal) {
      const dataJson = JSON.parse(dataLocal)
      console.log(dataJson)
      setStartDateDisplay(dataJson.display[0].start_date)
      setEndDateDisplay(dataJson.display[0].end_date)
      setStartDateRedeem(dataJson.redeem[0].start_date)
      setEndDateRedeem(dataJson.redeem[0].end_date)
      setRedeemLimit(dataJson.quota_campaign[0].period_limit)
      setRedeemQuota(dataJson.quota_member[0].period_limit)
    }
    if (props.editData) {
      console.log('props.editData', props.editData)
      let data0 = props.editData.dealRules.find((x:any)=> x.type == 'display')
      let data1 = props.editData.dealRules.find((x:any)=> x.type == 'redeem_period')
      let data2 = props.editData.dealRules.find((x:any)=> x.type == 'quota_campaign')
      let data3 = props.editData.dealRules.find((x:any)=> x.type == 'quota_member')
      console.log('xx', data0.start_date, '2023-06-20T04:03')
      //2023-06-20T04:03
      setStartDateDisplay(dayjs(data0.start_date).format('YYYY-MM-DDTHH:mm'))
      setEndDateDisplay(dayjs(data0.end_date).format('YYYY-MM-DDTHH:mm'))
      setStartDateRedeem(dayjs(data1.start_date).format('YYYY-MM-DDTHH:mm'))
      setEndDateRedeem(dayjs(data1.end_date).format('YYYY-MM-DDTHH:mm'))
      setRedeemLimit(data2.period_limit)
      setRedeemQuota(data3.period_limit)
    }
  }

  const create2 = async () => {
    let temp: any = []
    const body = {
      deal_id: props.dataID,
      display: [
        {
          start_date: dayjs(startDateDisplay).format('YYYY-MM-DDTHH:mm'),
          end_date: dayjs(endDateDisplay).format('YYYY-MM-DDTHH:mm'),
        },
      ],
      redeem: [
        {
          start_date: startDateRedeem
            ? dayjs(startDateRedeem).format('YYYY-MM-DDTHH:mm')
            : dayjs(startDateDisplay).format('YYYY-MM-DDTHH:mm'),
          end_date: endDateRedeem
            ? dayjs(endDateRedeem).format('YYYY-MM-DDTHH:mm')
            : dayjs(startDateDisplay).format('YYYY-MM-DDTHH:mm'),
        },
      ],
      quota_campaign: [{
        start_date: dayjs(startDateRedeem).format('YYYY-MM-DDTHH:mm'),
        end_date: dayjs(endDateRedeem).format('YYYY-MM-DDTHH:mm'),
        period_limit: redeemLimit,
        yearly_limit: null,
        monthly_limit: null,
        weekly_limit: null,
        week_start: 0,
        week_end: 6,
        daily_limit: null,
      }],
      quota_member: [{
        start_date: dayjs(startDateRedeem).format('YYYY-MM-DDTHH:mm'),
        end_date: dayjs(endDateRedeem).format('YYYY-MM-DDTHH:mm'),
        period_limit: redeemQuota,
        yearly_limit: null,
        monthly_limit: null,
        weekly_limit: null,
        week_start: null,
        week_end: null,
        daily_limit: null,
      }],
    }
    console.log(body)
    if (dataLocal) {
      props.click(2)
    } else Swal.fire({
      title: '',
      text: 'Confirm Create',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = await axios.put(`${PVL_URL2}/deal-rule/${props.dataID}`, body).then(async (res) => {
          const myJSON = JSON.stringify(body)
          localStorage.setItem('data2', myJSON)
          await Swal.fire('Success', 'Success', 'success')
          if(!props.editData) {
            props.click(2)
          } else {
            navigate(-1)
          }
        })
        .catch((err) => {
          Swal.fire('Create !', 'Your can not Create. !! ' + err, 'error')
        })
      }
    })
  }

  const [dealID, setDealID] = useState<any>(null)
  const [id, setID] = useState<any>(0)

  const [display, setDisplay] = useState<any>(null)
  //const [display, setDisplay] = useState<any>(null)

  const [quota_campaign, setQuota_campaign] = useState<any>(null)
  const [quota_member, setQuota_member] = useState<any>(null)
  const [redeem, setRedeem] = useState<any>(null)

  useEffect(
    () => {
      getStep2Data()
      console.log(props)
    },
    [] // Only re-call effect if value or delay changes
  )

  const uploadImage = async (e: any) => {
    if (e.target.files.length) {
      e.preventDefault()
      var _URL = window.URL || window.webkitURL
      var file = e.target.files[0]
      var formdata = new FormData()
      formdata.append('image', file)
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
      }
      const data = await axios.post(`${API_URL}/upload`, formdata)
    }
  }

  const [loading, setLoading] = useState(false)
  const formik = useFormik<DataStep2>({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      console.log(values)
      setLoading(true)
      setTimeout(async () => {
        //values.communications.email = data.communications.email
        //values.communications.phone = data.communications.phone
        //values.allowMarketing = data.allowMarketing
        const updatedData = Object.assign(data, values)
        setData(updatedData)
        Swal.fire({
          title: '',
          text: 'Confirm Edit',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            const data0 = await axios
              .put(`${API_URL}/bo/participant/${1}`, {
                //firstname: values.fName,
                //lastname: values.lName,
                //mobile_number: values.contactPhone,
              })
              .then(async (res) => {
                await Swal.fire('Success', 'Success', 'success')
                navigate(-1)
              })
              .catch((err) => {
                Swal.fire('Edit !', 'Your can not Edit. !! ' + err, 'error')
              })
          }
        })

        setLoading(false)
      }, 1000)
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>วันที่แสดง</label>

              <div className='col-lg-8'>
                <div className='row'>
                  <div className='col-lg-3 fv-row'>
                    <div className='form-inline' style={{marginBottom: '25px'}}>
                      <input
                        id='datestart'
                        type='datetime-local'
                        value={startDateDisplay}
                        defaultValue='DD/MM/YYYYTHH:mm'
                        style={{
                          height: '38px',
                          width: '185px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0',
                        }}
                        onChange={(e: any) => {
                          setStartDateDisplay(e.target.value)
                          console.log(e.target.value)
                          setChange(true)
                        }}
                      />
                    </div>
                  </div>

                  <div className='col-lg-3 fv-row'>
                    <div className='form-inline' style={{marginBottom: '25px'}}>
                      <input
                        id='datestart'
                        type='datetime-local'
                        value={endDateDisplay}
                        defaultValue='DD/MM/YYYYTHH:mm'
                        style={{
                          height: '38px',
                          width: '185px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0',
                        }}
                        onChange={(e: any) => {
                          setEndDateDisplay(e.target.value)
                          console.log(e.target.value)
                          setChange(true)
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>วันที่ให้แลกรางวัล</label>

              <div className='col-lg-8'>
                <div className='row'>
                  <div className='col-lg-3 fv-row'>
                    <div className='form-inline' style={{marginBottom: '25px'}}>
                      <input
                        id='datestart'
                        type='datetime-local'
                        value={startDateRedeem}
                        defaultValue='DD/MM/YYYYTHH:mm'
                        style={{
                          height: '38px',
                          width: '185px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0',
                        }}
                        onChange={(e: any) => {
                          setStartDateRedeem(e.target.value)
                          console.log(e.target.value)
                          setChange(true)
                        }}
                      />
                    </div>
                  </div>

                  <div className='col-lg-3 fv-row'>
                    <div className='form-inline' style={{marginBottom: '25px'}}>
                      <input
                        id='datestart'
                        type='datetime-local'
                        value={endDateRedeem}
                        placeholder={'sss'}
                        defaultValue='DD/MM/YYYYTHH:mm'
                        style={{
                          height: '38px',
                          width: '185px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0',
                        }}
                        onChange={(e: any) => {
                          setEndDateRedeem(e.target.value)
                          console.log(e.target.value)
                          setChange(true)
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>จำนวนผู้เข้าร่วมสูงสุด</label>

              <div className='col-lg-8'>
                <div className='row'>
                  {/*<div className='col-lg-3 fv-row'>
                    <div className='form-inline' style={{marginBottom: '25px'}}>
                      <input
                        id='datestart'
                        type='datetime-local'
                        //value={startDateDisplay}
                        defaultValue='DD/MM/YYYYTHH:mm'
                        style={{
                          height: '38px',
                          width: '185px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0',
                        }}
                        onChange={(data) => {}}
                      />
                    </div>
                  </div>

                  <div className='col-lg-3 fv-row'>
                    <div className='form-inline' style={{marginBottom: '25px'}}>
                      <input
                        id='datestart'
                        type='datetime-local'
                        //value={startDateDisplay}
                        defaultValue='DD/MM/YYYYTHH:mm'
                        style={{
                          height: '38px',
                          width: '185px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0',
                        }}
                        onChange={(data) => {}}
                      />
                    </div>
                  </div>*/}
                  <div className='col-lg-3 fv-row ml-3'>
                    <input
                      //disabled={true}
                      value={redeemLimit}
                      type='number'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='จำนวนสิทธิ์ต่อคน'
                      onChange={(e: any) => {
                        setRedeemLimit(e.target.value)
                        console.log(e.target.value)
                        setChange(true)
                      }}
                      //{...formik.getFieldProps('contactPhone')}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>จำกัดการให้รางวัล</label>

              <div className='col-lg-8'>
                <div className='row'>
                  {/*<div className='col-lg-3 fv-row'>
                    <div className='form-inline' style={{marginBottom: '25px'}}>
                      <input
                        id='datestart'
                        type='datetime-local'
                        //value={startDateDisplay}
                        defaultValue='DD/MM/YYYYTHH:mm'
                        style={{
                          height: '38px',
                          width: '185px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0',
                        }}
                        onChange={(data) => {}}
                      />
                    </div>
                  </div>

                  <div className='col-lg-3 fv-row'>
                    <div className='form-inline' style={{marginBottom: '25px'}}>
                      <input
                        id='datestart'
                        type='datetime-local'
                        //value={startDateDisplay}
                        defaultValue='DD/MM/YYYYTHH:mm'
                        style={{
                          height: '38px',
                          width: '185px',
                          backgroundColor: '#F4F6F9',
                          borderRadius: '5px',
                          borderWidth: '0',
                        }}
                        onChange={(data) => {}}
                      />
                    </div>
                  </div>*/}
                  <div className='col-lg-3 fv-row ml-3'>
                    <input
                      //disabled={true}
                      value={redeemQuota}
                      type='number'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='จำนวนสิทธิ์ต่อคน'
                      onChange={(e: any) => {
                        setRedeemQuota(e.target.value)
                        console.log(e.target.value)
                        setChange(true)
                      }}
                      //{...formik.getFieldProps('contactPhone')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className='card-footer d-flex justify-content-end py-6 px-9'>
        <button
          //type='submit'
          className='btn btn-primary marginSet'
          disabled={loading}
          onClick={() => {
            //props.handleChild(2)
            //setStep(Number(step) + 1)
            props.clickback(2)
            console.log('press')
          }}
        >
          {!loading && 'Back'}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <button
          //type='submit'
          className='btn btn-primary ml-4'
          disabled={loading}
          onClick={async () => {
            //props.handleChild(2)
            //setStep(Number(step) + 1)
            await create2()
            //props.click(2)
            console.log('press')
          }}
        >
          {!loading && 'Next'}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </div>
  )
}

export {Step2}
